import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $CurrentPOIInfoOrNull } from '@poi/shared/current-poi-info';
import { POITDK } from '@poi/head/tdk';
import { POIFacebook } from '@poi/head/facebook';
import { POIOG } from '@poi/head/og';
import { POITwitter } from '@poi/head/twitter';
import { FallbackPageHelmet } from '~/components/fallback-page-helmet';

export const POIHead: FC = () => {
  const poi = useAtomValue($CurrentPOIInfoOrNull);

  if (poi) {
    return (
      <>
        <POITDK />
        <POIFacebook />
        <POIOG />
        <POITwitter />
      </>
    );
  }

  return <FallbackPageHelmet />;
};
